import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useWallet } from "@solana/wallet-adapter-react";
import UnauthorizedGuard from "../UnauthorizedGuard";
import axiosInstance from "../../config/axios";

const ProtectedRoute = ({ children }) => {
  const { connected } = useWallet();
  const location = useLocation();
  const [isUnauthorized, setIsUnauthorized] = useState(false);
  const [showUnauthorized, setShowUnauthorized] = useState(false);

  // Reset unauthorized state ketika path berubah
  useEffect(() => {
    setIsUnauthorized(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!connected) {
      setShowUnauthorized(true);
    } else {
      setShowUnauthorized(false);
    }
  }, [connected]);

  // Handle axios interceptor untuk 401
  useEffect(() => {
    const interceptor = axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          setIsUnauthorized(true);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosInstance.interceptors.response.eject(interceptor);
    };
  }, []);

  // Handle fetch untuk 401 (backup)
  useEffect(() => {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      try {
        const response = await originalFetch(...args);
        if (response.status === 401) {
          setIsUnauthorized(true);
        }
        return response;
      } catch (error) {
        throw error;
      }
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  if (isUnauthorized || showUnauthorized) {
    return <UnauthorizedGuard />;
  }

  return connected ? children : null;
};

export default ProtectedRoute;
